import script from "./cnt-rich_text.vue?vue&type=script&lang=ts&setup=true"
export * from "./cnt-rich_text.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__